<template>

  <div class="home">
    <Navbar :is-active="5"></Navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>Menu QuickPay</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/UsuariosB2B" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-globe"></i>
            </div>
            <div class="tab__text">
              <p>Usuarios B2B</p>
            </div>
          </router-link>
          <router-link to="/UsuariosB2C" class="tab ">
            <div class="tab__icon">
              <i class="fas fa-shopping-bag"></i>
            </div>
            <div class="tab__text">
              <p>Usuarios B2C</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Usuario B2B / <span>Nuevo usuario </span></h2>
        </div>
        <div class="page__subtitle">
          <h3>Información </h3>
        </div>
        <section class="page__filters">
          <div class="input">
            <p>Ruc</p>
            <input type="text" v-model="company_ruc">
          </div>
          <div class="input">
            <p>Razon social</p>
            <input type="text" v-model="company_name">
          </div>
          <div class="input">
            <p>Grupo de negocio</p>
            <select v-model="company_bus_group_id">
              <option disabled value="">Seleccionar</option>
              <option :value="business_groups.id" v-for="business_groups of business_group" :key="business_groups.id">{{business_groups.name}}</option>
            </select>
          </div>
          <div class="input">
            <p>Tipo de negocio</p>
            <select v-model="company_bus_type_id">
              <option disabled value="">Seleccionar</option>
              <option :value="business_types.id" v-for="business_types of business_type" :key="business_types.id">{{business_types.name}}</option>
            </select>
          </div>
          <div class="input">
            <p>Conexión pasarela de pago</p>
            <select v-model="company_gat_connection_id">
              <option disabled value="">Seleccionar</option>
              <option :value="gateway_connections.id" v-for="gateway_connections of gateway_connection" :key="gateway_connections.id">{{gateway_connections.name}}</option>
            </select>
          </div>
          <div class="input">
            <p>Tipo de conciliacion</p>
            <select v-model="company_rec_type_id">
              <option disabled value="">Seleccionar</option>
              <option :value="reconciliation_types.id" v-for="reconciliation_types of reconciliation_type" :key="reconciliation_types.id">{{reconciliation_types.name}}</option>

            </select>
          </div>
          <div class="input">
            <p>Estado</p>
            <select v-model="company_status">
              <option disabled value="">Seleccionar</option>
              <option value="1">Activo</option>
              <option value="0">Inactivo</option>
            </select>
          </div>
          <hr/>
          <br/>
          <br/>
          <div class="page__title">
            <h2> <span>Datos de contacto </span></h2>
          </div>
          <div class="input">
            <p>Nombre</p>
            <input type="text" v-model="company_contact_name">
          </div>
          <div class="input">
            <p>Apellido</p>
            <input type="text" v-model="company_contact_lastname">
          </div>
          <div class="input">
            <p>Correo</p>
            <input type="text" v-model="company_contact_email">
          </div>
          <div class="input">
            <p>Celular</p>
            <input type="text" v-model="company_contact_cellphone">
          </div>
        </section>
        <div class="page__subtitle">
          <h3>Imágen de la Empresa</h3>
        </div>
        <section class="page__product">
          <div class="product__image">
            <img :src="imagen" alt="Subir imagen">
          </div>
          <div class="product__buttons">

            <button>
              <span>Cargar Imagen</span>
              <i class="fas fa-upload"></i>
              <input type="file" id="input_file" @change="change_file" ref="fileupload">
            </button>

            <button @click="deleteImagen()">
              <span>Eliminar Imagen</span>
              <i class="far fa-trash-alt"></i>
            </button>
          </div>
        </section>
        <section class="page__actions">
          <button>
            <span>Cancelar</span>
            <i class="fa fa-times-circle"></i>
          </button>
          <button @click="saveClient">
            <span>Guardar</span>
            <i class="fa fa-circle-check"></i>
          </button>
        </section>
      </div>
    </div>
  </div>

</template>

<script>
// @ is an alias to /src
import axios from "axios";
import OpenArrow from '@/components/OpenArrow.vue';
import HiddenArrow from '@/components/HiddenArrow.vue';
import Navbar from '@/components/NavBar'

export default {
  name: 'AddClientB2B',
  components: {
    OpenArrow,
    HiddenArrow,
    Navbar
  },
  data(){
    return{
      sl_in: '',
      sl_name: '',
      reconciliation_type: '',
      gateway_connection: '',
      customer_type: '',
      business_type: '',
      business_group: '',
      company_ruc: '',
      company_name:'',
      company_bus_group_id:'',
      company_bus_type_id:'',
      company_cus_type_id:1,
      company_gat_connection_id:'',
      company_rec_type_id:'',
      company_status:'',
      company_contact_name:'',
      company_contact_lastname:'',
      company_contact_email:'',
      company_contact_cellphone:'',
      company_url:'',
      usuario: '',
      fecha: '',
      file: null,
      imagen:
        location.protocol +
        "//" +
        location.host +
        "/default/default_product.jpg",
    }
  },
  created() {
    this.usuario = localStorage.getItem('usuario');
    this.getDate();
    this.getSelects();
  },
  methods:{
    change_file(event) {
      if (typeof event.target.files[0] !== "undefined") {
        this.file = event.target.files[0];
        let reader = new FileReader();
        if (
          event.target.files[0].type === "image/png" ||
          event.target.files[0].type === "image/jpeg" ||
          event.target.files[0].type === "image/jpg"
        ) {
          reader.onload = (e) => {
            this.imagen = e.target.result;
          };
        } else {
          this.$swal({
            position: "center",
            icon: "error",
            title: "El archivo no es un formato de imagen",
            showConfirmButton: false,
            timer: 2000,
          });
        }
        reader.readAsDataURL(this.file);
      }
    },
    deleteImagen() {
      this.$refs.fileupload.value = null;
      this.imagen =
        location.protocol +
        "//" +
        location.host +
        "/default/default_product.jpg";
    },
    zeroFill(number, width) {
        width -= number.toString().length
        if (width > 0) {
          return (
              new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
          )
        }
        return number + ''
      },
    getDate() {
        let dias = [
          'Lunes',
          'Martes',
          'Miercoles',
          'Jueves',
          'Viernes',
          'Sabado',
          'Domingo'
        ]
        let meses = [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ]

        let date = new Date()

        const fechaNum = date.getDate()
        const mes_name = date.getMonth()

        let day = date.getDay() === 0 ? 6 : date.getDay() - 1
        this.fecha = dias[day] + ' ' + this.zeroFill(fechaNum, 2) + ' de ' + meses[mes_name]
      },
    changePage(url) {
      this.$router.push(url)
    },
    handleClick(){
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    backCompany(){
      this.$router.push('/comercial')
    },
    async getSelects(){
      await axios.get('general/elements/selects').then(res => {
        this.business_group = res.data.data.business_group
        this.business_type = res.data.data.business_type
        this.customer_type = res.data.data.customer_type
        this.gateway_connection = res.data.data.gateway_connection
        this.reconciliation_type = res.data.data.reconciliation_type
      })
    },
    async saveClient(){
      try {
        const formData = new FormData();
        formData.append("company_ruc", this.company_ruc);
        formData.append("company_name", this.company_name);
        formData.append("company_bus_group_id", this.company_bus_group_id);
        formData.append("company_bus_type_id", this.company_bus_type_id);
        formData.append("company_cus_type_id", this.company_cus_type_id);
        formData.append("company_gat_connection_id", this.company_gat_connection_id);
        formData.append("company_rec_type_id", this.company_rec_type_id);
        formData.append("company_status", this.company_status);
        formData.append("company_contact_name", this.company_contact_name);
        formData.append("company_contact_lastname", this.company_contact_lastname);
        formData.append("company_contact_email", this.company_contact_email);
        formData.append("company_contact_cellphone", this.company_contact_cellphone);
        formData.append("file", this.file);

        const response = await axios.post('general/company', formData)

        if(response.status === 200){
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Sucursal creado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
          this.$router.push('/UsuariosB2B')
        }
      } catch (error) {
        console.log(error)
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      }
    }
  }
}


</script>

<style scoped>
.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}

/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
  width: 20%;
}
.home .navbar__right .profile {
  display: flex;
  width: 100%;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
a:hover {
  text-decoration: none;
}
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;
}
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 50px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}
/*----------------------------*/
/*----------------------------*/
/*----------------------------*/
.body__containt {
  height: fit-content;
  min-height: 87vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  overflow-y: scroll;
}
.body__containt .page__subtitle,
.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #000;
  font-size: 25px;
}
.body__containt .page__title h2 span {
  color: #ff3128;
}
.body__containt .page__subtitle h3  {
  color: #ff3128;
  font-weight: 600;
  font-size: 20px;
}

/*-----FILTERS------*/

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 40px;
}

.body__containt .page__filters .input {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #938f8f;
  display: flex;
  flex-direction: column;
  padding: 7px 15px;
  transition: 0.4s ease;

}

.body__containt .page__filters .input:hover {
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.05);
}

.body__containt .page__filters .input span {
  font-size: 15px;
  color: #938f8f;
}
.body__containt .page__filters .input p {
  margin: 0;
}

.page__filters input, select{
  outline:none;
  border: none;
  background: white;
}

/*-----PRODUCT------*/
.page__product {
  width: 100%;
  display: flex;
  padding-bottom: 50px;
  border-bottom: 1px solid #938f8f;
}

.page__product .product__image,
.page__product .product__buttons {
  /* width: 50%; */
  display: flex;
  align-items: center;
}
.page__product .product__image {
  width: 400px;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.page__product .product__image img {
  width: 100%;
  object-fit: cover;
  transition: 1s ease;
}
.page__product .product__image img:hover {
  transform: scale(1.1) rotate(1deg);
}
.page__product .product__buttons {
  width: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.page__actions button,
.page__product .product__buttons button {
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.page__actions button:hover,
.page__product .product__buttons button:hover {
  transform: scale(1.1);
}
.page__actions button:nth-child(2),
.page__product .product__buttons button:nth-child(1) {
  background: #32ba7c;
}
.page__product .product__buttons button:nth-child(2) {
  background: #262626;
}
.page__product .product__buttons button:hover:nth-child(2) {
  background: #ff3128;
}

/*------------------------*/
/*------------------------*/
/*------------------------*/

.page__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px 0;
  gap: 20px;
}

.page__actions button:nth-child(1) {
  background: #ff3128;
}

/*------BODY------*/
.body__sidebar.open{
  display: none;
}
#input_file{
  cursor: pointer;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
}


</style>
